import { TFilterRequest } from "../Commons/filter.model";

export interface TProductFilterRequest extends TFilterRequest
{
    keyword?:string
    status?:ProductStatus
}
export interface TProductDto {
    id?: number;
    categoryId: number;
    branchId: number;
    unitId: number;
    status: ProductStatus;
    name: string;
    code: string;
    description?: string;
    width: number;
    height: number;
    length: number;
    weight: number;
   
    importPrice:number
    salePrice:number
}
export interface TProductItem extends TProductDto{
    categoryName: string;
    branchName: string;
    unitName: string;
}
export enum  ProductStatus {
    UnActive = 0,
    Active = 1,
    Deleted = 3
}